/**
 * SMT Construction — surveying crosshair mark.
 * Replicates the reticle of a theodolite / total station:
 * outer circle + 4 tick lines extending beyond it + centre dot.
 * These instruments are on every SMT site — the mark says "precision" not "generic link".
 */
export default function ArrowMark({ size = 12 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {/* Outer circle */}
      <circle cx="7" cy="7" r="4" stroke="currentColor" strokeWidth="1.4" />
      {/* Top tick */}
      <line x1="7" y1="1"  x2="7" y2="2.8"  stroke="currentColor" strokeWidth="1.4" strokeLinecap="square" />
      {/* Bottom tick */}
      <line x1="7" y1="11.2" x2="7" y2="13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="square" />
      {/* Left tick */}
      <line x1="1"  y1="7" x2="2.8"  y2="7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="square" />
      {/* Right tick */}
      <line x1="11.2" y1="7" x2="13" y2="7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="square" />
      {/* Centre dot */}
      <circle cx="7" cy="7" r="1.2" fill="currentColor" />
    </svg>
  );
}
